import React from 'react';
import './MinicuotasBadge.scss';
const MinicuotasBadge = ({ show }) => {
  return (
    <span className="version-options--items-item-new version-options--items-item-new--minicuotas">
      Mini Cuotas
    </span>
  );
};

export default MinicuotasBadge;